import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastMessages: Array<{ title: string; message: string; type: string }> = [];

  constructor() {}

  showToast(title: string, message: string, type: 'success' | 'error' | 'info') {
    this.toastMessages.push({ title, message, type });
  }

  getToasts() {
    return this.toastMessages;
  }

  clearToasts() {
    this.toastMessages = [];
  }
}